const APIRoot = `${process.env.VUE_APP_API_ROOT}/api`

// const accessToken = 'vjseriuhsguilhaeruig'
const accessToken = 'ePUqk2n4rU2HSVUJu3VIqyH4UIhOvGydYfFa9mzhyc89'

export { APIRoot, accessToken }